import { render, staticRenderFns } from "./CanvasToolbar.vue?vue&type=template&id=2bab42a5&scoped=true"
import script from "./CanvasToolbar.vue?vue&type=script&lang=js"
export * from "./CanvasToolbar.vue?vue&type=script&lang=js"
import style0 from "./CanvasToolbar.vue?vue&type=style&index=0&id=2bab42a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bab42a5",
  null
  
)

export default component.exports